import { environment } from './../../environments/environment';
import { DataSource } from '@angular/cdk/collections';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginationBaseService, PaginationResult } from 'ng-lightquery';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AnalysisRequestDto } from '../models/dto/analysis-request.dto';
import { Constants } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class AnalysisRequestsTableService extends PaginationBaseService<AnalysisRequestDto>
  implements DataSource<AnalysisRequestDto> {

  constructor(protected http: HttpClient) {
    super(http);
    this.baseUrl = `${environment.apiUrl}${Constants.analysisRequestsEndpoint}`;
    this.sort = {
      isDescending: true,
      propertyName: 'created'
    };
  }

  connect(): Observable<AnalysisRequestDto[]> {
    return this.paginationResult.pipe(map((r: PaginationResult<AnalysisRequestDto>) => r.data));
  }

  disconnect() { }
}